export enum TipoValorPregunta {
  Texto = 1,
  Numerico = 2,
  Fecha = 3,
  Decimal = 4,
  Correo = 5,
}
